import React from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { RootAppState } from 'store/types';
import { getStateOfCheckListItem } from 'store/resource/checklist/selectors';
import * as actions from 'store/resource/checklist/actions';
import SwitchButton from 'components/common/SwitchButton';
import { SWITCH_BUTTON_LAYOUT } from 'constants/components';
import { getContents } from 'store/contents/selectors';
import ContentList from 'components/contents/ContentList/ContentList';
import { getTextContent } from 'utils/string';
import { KEYS } from 'constants/common';
import {
  CheckListWrapper,
  CheckButtonWrapper,
  TextContent,
  ChecklistItemTitle,
  TextTitle
} from './ChecklistItem.styled';

type ChecklistItemProps = {
  inverted: boolean;
  itemId: string;
  childrenElements: any[];
  content: string;
  linkTabIndex?: number;
};

type ChecklistItemState = {
  isChecked: boolean;
};

class ChecklistItem extends React.PureComponent<
  ChecklistItemProps & ConnectedProps<typeof connector>,
  ChecklistItemState
> {
  constructor(props: ChecklistItemProps & ConnectedProps<typeof connector>) {
    super(props);
    this.state = {
      isChecked: false
    };
  }

  onclickHandler = () => {
    this.props.actions.toggleCheck({ itemId: this.props.itemId, isChecked: !this.state.isChecked });
    this.setState({ isChecked: !this.state.isChecked });
  };

  keyDownHandler = (event: any) => {
    if (
      event.key?.toLowerCase() === KEYS.ENTER.toLowerCase() ||
      event.key?.toLowerCase() === KEYS.SPACEBAR.toLowerCase()
    ) {
      this.onclickHandler();
    }
  };

  componentDidMount() {
    this.setState({ isChecked: this.props.stateOfCheckListItem });
  }

  componentDidUpdate() {
    if (this.props.stateOfCheckListItem !== this.state.isChecked) {
      this.setState({ isChecked: this.props.stateOfCheckListItem });
    }
  }

  render() {
    const { inverted, childrenContents, content, linkTabIndex } = this.props;
    const tabIndex = linkTabIndex || linkTabIndex === 0 ? linkTabIndex : 1;
    return (
      <CheckListWrapper className="checklistItem">
        <ChecklistItemTitle>
          <CheckButtonWrapper>
            <SwitchButton
              layout={SWITCH_BUTTON_LAYOUT.CHECKLIST}
              multiple={true}
              selected={this.state.isChecked}
              tabIndex={tabIndex}
              onKeyDown={this.keyDownHandler}
              onClick={this.onclickHandler}
            />
          </CheckButtonWrapper>
          <TextTitle>{getTextContent(content)}</TextTitle>
        </ChecklistItemTitle>
        <TextContent>
          {childrenContents.length > 0 && (
            <ContentList
              items={childrenContents}
              isLoading={false}
              inverted={inverted}
              linkTabIndex={linkTabIndex}
            />
          )}
        </TextContent>
      </CheckListWrapper>
    );
  }
}

function mapStateToProps(state: RootAppState, ownProps: ChecklistItemProps) {
  return {
    stateOfCheckListItem: getStateOfCheckListItem(state, ownProps.itemId),
    childrenContents: getContents(state, ownProps.childrenElements)
  };
}

function mapDispatchToProps(dispatch: Dispatch): { [key: string]: any } {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(ChecklistItem);
